import Factory from '@/utils/request'

const baseURL =
  process.env.NODE_ENV === 'development'
    ? `${process.env.VUE_APP_NEWS_URL}/portal/api`
    : '/portal/api'

export default Factory(
  {
    baseURL
  },
  () => false
)
